import { Box, Text } from '@chakra-ui/react';
import cn from 'classnames';
import Link from 'next/link';
import React from 'react';

import Image from '@/app/_components/Image';
import { useRoutesConfig } from '@/hooks/routes-config';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { assetsUri } from '@/services/api.service';
import { getBrowseItemLink } from '@/services/link.service';
import {
  formatBodyUrlPath,
  formatUrlPath,
} from '@/services/string-format.service';
import {
  BrowseItemTypes,
  BrowseTypes,
} from '@/types/used-cars/used-cars.types';
import { directusImageLoader } from '@/utils/loaders';

import styles from './browse-item.module.scss';

export const BodyBrowseItem: React.FC<{
  item: BrowseItemTypes;
  name?: BrowseTypes;
  className?: string;
  type?: string;
}> = ({ item, name, className }) => {
  const imageUri = `${assetsUri}/${item.image}?key=image-82-42`;
  const routes = useRoutesConfig();
  const { activeCarType } = useFiltersQuery();

  let linkUrl = `${getBrowseItemLink(name, activeCarType, routes)}${formatUrlPath(item.name)}`;

  if (name === BrowseTypes.body) {
    linkUrl = `${getBrowseItemLink(name, activeCarType, routes)}`;
    linkUrl = linkUrl.replace('%body%', formatBodyUrlPath(item.name));
  } else if (name === BrowseTypes.model) {
    linkUrl = `${getBrowseItemLink(name, activeCarType, routes)}/kia/${formatBodyUrlPath(item.name)}`;
  } else if (item.link) {
    linkUrl = item.link;
  }
  return item.image ? (
    <Link href={linkUrl} className={styles.itemBrandLink} prefetch={false}>
      <Box
        className={cn(
          styles.itemBody,
          {
            [styles.itemDisabled as string]: item?.isDisabled,
          },
          className,
        )}
      >
        <Box width={'100%'}>
          <Box className={styles.itemBodyImageWrapper}>
            <Image
              className={styles.image}
              src={imageUri}
              loader={directusImageLoader}
              alt={item.fullName || ''}
              title={item.fullName || ''}
              height={42}
              width={82}
            />
          </Box>
          <Text className={styles.text}>{item.name}</Text>
        </Box>
      </Box>
    </Link>
  ) : null;
};
